<template>
  <div id="app" class="wip-container">
    <div class="wip-content">
      <div class="wip-icon">
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
          <circle cx="60" cy="60" r="55" stroke="#FF6B6B" stroke-width="2" />
          <path
            d="M60 30V90"
            stroke="#FF6B6B"
            stroke-width="3"
            stroke-linecap="round"
          />
          <circle cx="60" cy="100" r="4" fill="#FF6B6B" />
        </svg>
      </div>

      <h1>En Construcció</h1>
      <p>Estem desenvolupant la web de Noctes!</p>

      <div class="loading-animation">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>

<style scoped>
#app {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  overflow: hidden;
}

.wip-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.wip-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
  color: white;
  height: 100%;
  width: 100%;
}

.wip-icon {
  margin-bottom: 40px;
  animation: float 3s ease-in-out infinite;
}

h1 {
  font-size: 3.5rem;
  margin-bottom: 15px;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.wip-content > p:nth-of-type(1) {
  font-size: 1.25rem;
  margin-bottom: 50px;
  opacity: 0.95;
  max-width: 400px;
}

.loading-animation {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 30px;
}

.dot {
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

.coming-soon {
  font-size: 1rem;
  opacity: 0.8;
  letter-spacing: 2px;
  font-weight: 500;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  h1 {
    font-size: 2.5rem;
  }

  .wip-content > p:nth-of-type(1) {
    font-size: 1rem;
  }

  .wip-icon {
    margin-bottom: 30px;
  }
}
</style>
